import { Attribute } from './Attribute.js';

export const CHANNELS_ATTRIBUTE_TYPE = 'ChannelsAttribute';

/**
 * Represents FTTH channels list.
 *
 * @property {{name: string, logoUrl: ?string}[]} values Array of channels
 */
export class ChannelsAttribute extends Attribute {
  constructor({ values }) {
    super();
    this.values = values;
    this.isReadOnly = true;
    this.type = CHANNELS_ATTRIBUTE_TYPE;
  }
}
